import React from 'react'
import { AiFillAppstore } from "react-icons/ai";
import { FaMobile, FaGlobe, FaCode } from "react-icons/fa";
import { SiProgress, SiAntdesign, SiWeb3Dotjs, SiChatbot } from "react-icons/si";
import Title from '../layouts/Title';
import Card from './Card';

const Features = () => {
  return (
    <section
      id="features"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <Title title="Features" des="What I Do" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
        <Card
          title="Web Developer"
          des="Crafting captivating, responsive websites. Whether it's a new site or a redesign.
          I turn your digital vision into reality."
          icon={<FaCode />}
        />
        <Card
          title="AI & Chatbot Developer"
          des="Boost engagement with my AI Chatbot services. I am expert in creating smart, 
          conversational agents for seamless user experiences and real-time assistance."
          icon={<SiChatbot />}
        />
        <Card
          title="Hosting Websites"
          des="Secure your online presence with my one-stop solution. Register your ideal domain,
           and I'll handle hosting for an always accessible, secure, and fast-loading website or app."
          icon={<FaGlobe />}
        />
      </div>
    </section>
  );
}

export default Features